import React from 'react'
import PropTypes from 'prop-types'
import { HeaderFour, ProgressStatusMedium } from 'secondstep-components'
import CreateCourse from 'experienceComponents/CreateCourse'
import { getCourseInstancePath } from './helpers'

import {
  CardWrapper,
  InfoBox,
  StyledGradeTile,
  Wrapper,
} from './component.styles'

const ClassCard = React.forwardRef(
  (
    {
      className,
      dataTestId,
      defaultUnit,
      displayTitle,
      gradeDisplayTitle = '',
      instance,
      program,
      onBlur,
      onClick,
      onFocus,
      scoID,
      setFocus,
      tier = 1,
      totalAmount,
      totalComplete,
    },
    ref,
  ) => {
    const course = {
      instance,
      scoId: scoID,
      title: displayTitle,
    }
    const courseInstancePath = getCourseInstancePath({
      program,
      gradeDisplayTitle,
      instance,
      tier,
      defaultUnit,
    })

    return (
      <Wrapper className="class-card" onBlur={onBlur} onFocus={onFocus}>
        <CardWrapper
          className={className}
          dataTestId={dataTestId}
          onClick={() => onClick(courseInstancePath)}
          tier={tier}
        >
          <StyledGradeTile
            dataTestId="classGrade"
            displayText={gradeDisplayTitle}
            isStatic
            size="small"
            tier={tier}
          />
          <InfoBox>
            {displayTitle && (
              <HeaderFour dataTestId="className">{displayTitle}</HeaderFour>
            )}
            <ProgressStatusMedium
              dataTestId={'classProgress'}
              totalAmount={tier === 2 ? null : totalAmount}
              totalComplete={totalComplete}
            />
          </InfoBox>
        </CardWrapper>
        <CreateCourse
          course={course}
          courseInstanceName={displayTitle}
          edit
          isClassCardMenu
          key={`create-course-${displayTitle}-${scoID}`}
          ref={ref}
          setFocus={setFocus}
        />
      </Wrapper>
    )
  },
)

ClassCard.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string.isRequired,
  defaultUnit: PropTypes.string,
  displayTitle: PropTypes.string,
  gradeDisplayTitle: PropTypes.string,
  instance: PropTypes.string,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  program: PropTypes.string,
  scoID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setFocus: PropTypes.func,
  tier: PropTypes.number,
  totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
ClassCard.displayName = 'ClassCardForwardedRef'
export default ClassCard
